import { render } from "./ClockStart.vue?vue&type=template&id=2e26f571"
import script from "./ClockStart.vue?vue&type=script&lang=js"
export * from "./ClockStart.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__